<template>
  <div class="about-us-container1">
    <app-navbar4 rootClassName="navbar4root-class-name2"></app-navbar4>
    <div class="about-us-header76">
      <div class="about-us-max-width1 thq-section-max-width">
        <div class="about-us-column1 thq-section-padding">
          <img alt="image" src="/yubaro-slash-200w.webp" class="about-us-image" />
          <h1 id="aboutH" class="about-us-text10 thq-heading-1">
            <span class="about-us-text11">Unlocking wealth,</span>
            <br class="about-us-text12" />
            <span class="about-us-text13">embracing possibilities</span>
            <br />
          </h1>
          <p class="about-us-text15 thq-body-large">
            <span>
              Welcome to Yubaro, your trusted partner in the world of alternative
              assets. Founded with a vision to democratize access to high-value
              assets, Yubaro brings together a community of passionate collectors
              and knowledgeable vendors to create a vibrant marketplace for unique
              and lucrative opportunities.
            </span>
            <br />
            <br />
            <span>
              Our mission is to provide a seamless and secure platform where you
              can explore, acquire, and grow your wealth through diverse asset
              classes. From rare whiskey casks and fine art to classic cars,
              luxury watches, and precious metals, Yubaro offers a curated
              selection of high-quality assets to suit every collector&apos;s
              portfolio.
            </span>
            <br />
            <br />
            <span>
              At Yubaro, we believe in the power of informed decisions. Our team
              of experts is dedicated to providing you with the latest market
              insights, trends, and analysis to help you make well-informed
              choices. We strive to ensure that your experience with us is not
              only profitable but also enriching and enjoyable.
            </span>
            <br />
            <br />
            <span>
              Join us on this exciting journey of discovering new possibilities
              and unlocking wealth through alternative assets. Whether you are a
              seasoned collector or just starting, Yubaro is here to guide you
              every step of the way.
            </span>
          </p>
        </div>
        <div class="about-us-content1">
          <div class="about-us-column2">
            <img
              alt="Hero Image"
              srcset="/about-us/photos//dan-burton-sdogdunfcjo-unsplash-1400w.webp 1200w, /about-us/photos/dan-burton-sdogdunfcjo-unsplash-tablet.webp 800w, /about-us/photos/dan-burton-sdogdunfcjo-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/dan-burton-sdogdunfcjo-unsplash-1400w.webp"
              class="about-us-placeholder-image10 thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              srcset="/about-us/photos//marvin-l-61szczl3mlk-unsplash-1400w.webp 1200w, /about-us/photos/marvin-l-61szczl3mlk-unsplash-tablet.webp 800w, /about-us/photos/marvin-l-61szczl3mlk-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/marvin-l-61szczl3mlk-unsplash-1400w.webp"
              class="about-us-placeholder-image11 thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              srcset="/about-us/photos//martin-pechy-r7-ccjcro48-unsplash-1400w.webp 1200w, /about-us/photos/martin-pechy-r7-ccjcro48-unsplash-tablet.webp 800w, /about-us/photos/martin-pechy-r7-ccjcro48-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/martin-pechy-r7-ccjcro48-unsplash-1400w.webp"
              class="about-us-placeholder-image12 thq-img-ratio-1-1"
            />
          </div>
          <div class="about-us-column3">
            <img
              alt="Hero Image"
              srcset="/about-us/photos//trevor-gerzen-fdfwkzw0hf4-unsplash-1400w.webp 1200w, /about-us/photos/trevor-gerzen-fdfwkzw0hf4-unsplash-tablet.webp 800w, /about-us/photos/trevor-gerzen-fdfwkzw0hf4-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/trevor-gerzen-fdfwkzw0hf4-unsplash-1400w.webp"
              class="about-us-placeholder-image13 thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              srcset="/about-us/photos//erol-ahmed-xsq8nukpao4-unsplash-1400w.webp 1200w, /about-us/photos/erol-ahmed-xsq8nukpao4-unsplash-tablet.webp 800w, /about-us/photos/erol-ahmed-xsq8nukpao4-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/erol-ahmed-xsq8nukpao4-unsplash-1400w.webp"
              class="about-us-placeholder-image14 thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              srcset="/about-us/photos//fawazlul-rizqi-jkud3suxcmw-unsplash-1400w.webp 1200w, /about-us/photos/fawazlul-rizqi-jkud3suxcmw-unsplash-tablet.webp 800w, /about-us/photos/fawazlul-rizqi-jkud3suxcmw-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/fawazlul-rizqi-jkud3suxcmw-unsplash-1400w.webp"
              class="about-us-placeholder-image15 thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              srcset="/about-us/photos//kent-lam-y0rrb835wjg-unsplash-1400w.webp 1200w, /about-us/photos/kent-lam-y0rrb835wjg-unsplash-tablet.webp 800w, /about-us/photos/kent-lam-y0rrb835wjg-unsplash-mobile.webp 480w"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/about-us/photos/kent-lam-y0rrb835wjg-unsplash-1400w.webp"
              class="about-us-placeholder-image16 thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
    </div>
    <app-features rootClassName="app-featuresroot-class-name"></app-features>
    <contact-us-bottom></contact-us-bottom>
    <app-footer></app-footer>
    <cookie-consent-banner
      rootClassName="cookie-consent-bannerroot-class-name1"
    ></cookie-consent-banner>
  </div>
</template>

<script>
import AppNavbar4 from '../components/navbar4'
import AppFeatures from '../components/app-features'
import ContactUsBottom from '../components/contact-us-bottom'
import AppFooter from '../components/footer'
import CookieConsentBanner from '../components/cookie-consent-banner'

export default {
  name: 'AboutUs',
  props: {},
  components: {
    AppNavbar4,
    AppFeatures,
    ContactUsBottom,
    AppFooter,
    CookieConsentBanner,
  },
  metaInfo: {
    title: 'About Us - Yubaro',
    meta: [
      {
        name: 'description',
        content:
          'Yubaro is an alternative asset marketplace giving users access to the gold, property, fine art, rare cars, whiskey casks and wine investments.',
      },
      {
        property: 'og:title',
        content: 'About Us - Yubaro',
      },
      {
        property: 'og:description',
        content:
          'Yubaro is an alternative asset marketplace giving users access to the gold, property, fine art, rare cars, whiskey casks and wine investments.',
      },
    ],
  },
}
</script>

<style scoped>
.about-us-container1 {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  background-color: #e0d5bb;
}
.about-us-header76 {
  gap: var(--dl-space-space-unit);
  width: 100%;
  height: auto;
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  flex-shrink: 0;
  padding-left: var(--dl-space-space-twounits);
  padding-right: var(--dl-space-space-twounits);
  flex-direction: row;
  justify-content: center;
}
.about-us-max-width1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.about-us-column1 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 50%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.about-us-image {
  top: 48px;
  left: 30px;
  width: 95px;
  height: 97px;
  z-index: 0;
  position: absolute;
  object-fit: cover;
}
.about-us-text10 {
  z-index: 100;
  font-style: normal;
  font-family: "Poppins";
  font-weight: 500;
  line-height: 0.8!important;
}
.about-us-text11 {
  font-size: 32px;
}
.about-us-text13 {
  font-size: 32px;
}
.about-us-text15 {
  font-family: "Poppins";
}
.about-us-content1 {
  gap: var(--dl-space-space-unit);
  width: 50%;
  height: 900px;
  display: flex;
  position: relative;
  align-items: center;
}
.about-us-column2 {
  gap: 16px;
  width: 50%;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
.about-us-placeholder-image10 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-placeholder-image11 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-placeholder-image12 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-column3 {
  gap: 16px;
  width: 50%;
  height: auto;
  display: flex;
  z-index: 1;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
.about-us-placeholder-image13 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-placeholder-image14 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-placeholder-image15 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
.about-us-placeholder-image16 {
  width: 100%;
  height: 400px;
  align-self: stretch;
  border-radius: var(--dl-radius-radius-radius4);
}
@media(max-width: 1200px) {
  .about-us-image {
    top: 47px;
    left: 33px;
  }
}
@media(max-width: 991px) {
  .about-us-header76 {
    padding-left: 0px;
    padding-right: 0px;
    flex-direction: column;
  }
  .about-us-max-width1 {
    flex-direction: column;
  }
  .about-us-column1 {
    width: 100%;
    padding-left: var(--dl-space-space-fiveunits);
    padding-right: var(--dl-space-space-fiveunits);
  }
  .about-us-content1 {
    width: 100%;
    height: auto;
    align-items: center;
    flex-direction: column;
  }
  .about-us-column2 {
    width: 100%;
    margin-top: 0px;
    flex-direction: row;
    justify-content: center;
  }
  .about-us-placeholder-image10 {
    width: 400px;
  }
  .about-us-placeholder-image11 {
    width: 400px;
  }
  .about-us-placeholder-image12 {
    width: 400px;
  }
  .about-us-column3 {
    width: 100%;
    flex-direction: row;
    justify-content: center;
  }
  .about-us-placeholder-image13 {
    width: 400px;
  }
  .about-us-placeholder-image14 {
    width: 400px;
    display: none;
  }
  .about-us-placeholder-image15 {
    width: 400px;
  }
  .about-us-placeholder-image16 {
    width: 400px;
  }
}
@media(max-width: 767px) {
  .about-us-column1 {
    position: relative;
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .about-us-image {
    top: 30px;
    left: 16px;
    width: 61px;
    height: 62px;
    position: absolute;
    align-self: flex-end;
  }
  .about-us-text10 {
    width: 100%;
    font-style: normal;
    text-align: left;
    font-family: Poppins;
    font-weight: 500;
  }
  .about-us-text11 {
    font-size: 32px;
    text-align: center;
  }
  .about-us-text12 {
    font-size: 32px;
  }
  .about-us-text13 {
    font-size: 32px;
  }
  .about-us-text15 {
    text-align: left;
  }
  .about-us-content1 {
    align-self: stretch;
  }
  .about-us-placeholder-image10 {
    width: 100%;
    height: 250px;
  }
  .about-us-placeholder-image11 {
    width: 100%;
    height: 250px;
  }
  .about-us-placeholder-image12 {
    width: 100%;
    height: 250px;
  }
  .about-us-column3 {
    align-self: stretch;
    margin-left: 0;
  }
  .about-us-placeholder-image13 {
    width: 100%;
    height: 250px;
  }
  .about-us-placeholder-image14 {
    width: 100%;
    height: 250px;
    display: none;
  }
  .about-us-placeholder-image15 {
    height: 250px;
  }
  .about-us-placeholder-image16 {
    height: 250px;
    display: flex;
  }
}
@media(max-width: 479px) {
  .about-us-column1 {
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .about-us-image {
    top: 9px;
    left: 2px;
    width: 49px;
    height: 49px;
  }
  .about-us-text10 {
    text-align: left;
  }
  .about-us-text11 {
    text-align: center;
  }
  .about-us-text15 {
    text-align: left;
  }
  .about-us-column2 {
    width: 100%;
  }
  .about-us-placeholder-image14 {
    display: none;
  }
}
</style>